import React, { useContext, useState } from "react";
import { RequestContext } from "../../context/RequestContext";
import DragAll from "./DragAll";
import JobUtils from "../../utils/JobsUtils";
import DraggableItem from "../drag-drop/DraggableItem";
import RequestUtils from "../../utils/RequestUtils";
import _ from "lodash";
import { Container, Row, Modal } from "react-bootstrap";
import { Text } from "../../constants/Text";
import './dragdrop.scss';
import { Tooltip } from "@material-ui/core";
import { StyledBlueButton } from "../../styles/BootstrapStyles";
import { ReactComponent as Info } from "../../assets/icons/information.svg";

const SourceDrag = () => {
    const {
        sourceLocation,
        sources,
        processes,
        jobType,
        jobKeysToFilename,
        deliveriesToSourceMapping,
        unMappedSources,
        _setJobKeysToFilename,
        stitchAssetName,
        isStitch,
        deliveries
    } = useContext(RequestContext);
    const sourceList = isStitch ? [_.sortBy(sources,"key")[0]] : sources;

    const buildSourceProcessKey = (sourceKey, processKey) => {
        return sourceKey + '_' + processKey;
    }

    const onFileNameUpdated = (filename, source, key) => {
        let updatedJobKeysToFilename = { ...jobKeysToFilename };
        updatedJobKeysToFilename[key] = filename;
        _setJobKeysToFilename(updatedJobKeysToFilename);
    };

    const onDragPrevent = () => {
        setModal(true);
    }

    const [showModal, setModal] = useState(false)
    return (
        <Container>

            <Modal className="modal"
                show={showModal}
                dialogClassName="modalDialog">
                <Modal.Header className="modalHeader">
                    <Modal.Title className="modalHeaderTitle">Invalid file name</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBody">
                    <p>Please revise the filename to remove invalid characters.</p>
                </Modal.Body>
                <Modal.Footer>
                    <StyledBlueButton
                        onClick={() => {
                            setModal(false)
                        }}
                        variant="secondary">
                        OK
                    </StyledBlueButton>
                </Modal.Footer>
            </Modal>

            <Row className="sourceDragHeaderRow">
                <label className="sourceDragHeaderLarge">Files</label>
                <label className="sourceDragHeaderSmall">(Drag below file(s) to the delivery section on the right)</label>
            </Row>
            <Row>
                <p className="deliveryText">
                    {Text.DELIVERY_TEXT}
                    <Tooltip title={Text.TOOLTIP_TITLE}
                        interactive
                        placement="top"
                        arrow
                        classes={{ tooltip: "deliveryTooltip" }}
                    >
                        <Info className="infoIcon" />
                    </Tooltip>
                </p>
            </Row>
            <Row>
                <DragAll items={sourceList} fileNames={
                    _.map(sourceList, (source, index) => {
                        let sourceKey = _.get(source, "key");
                        let extractedJobType = JobUtils.extractJobTypeProperty(jobType, "jobType");
                        if (!_.includes(JobUtils.getProcessors(), extractedJobType)) {
                            return [JobUtils.getDefaultFileName(
                                jobType,
                                sourceLocation,
                                source,
                                _.get(jobKeysToFilename, sourceKey),
                                null,
                                stitchAssetName,
                                isStitch)];
                        }else{
                            return _.map(processes, (process, processIndex) => {
                                let sourceProcessKey = buildSourceProcessKey(_.get(source, "key"), _.get(process, "key"));
                                return JobUtils.getDefaultFileName(
                                    jobType,
                                    sourceLocation,
                                    source,
                                    _.get(jobKeysToFilename, sourceProcessKey),
                                    process,
                                    stitchAssetName, isStitch)
                                })
                        }
                    })
                    .reduce((rec,item)=>{ return rec.concat(item )},[])
                } label="Drag All Files" canDrag={true} onDragPrevent={onDragPrevent} isNoDelivery= {_.isEmpty(deliveries)} jobType={JobUtils.extractJobTypeProperty(jobType, "jobType")} />
            </Row>
            <Row>
                <ul className="dragItemsUl">
                    {_.map(sourceList, (source, index) => {
                        let sourceKey = _.get(source, "key");
                        let extractedJobType = JobUtils.extractJobTypeProperty(jobType, "jobType");
                        let extractedSourceLocation = JobUtils.extractSourceLocationProperty(sourceLocation, "type");
                        if (!_.includes(JobUtils.getProcessors(), extractedJobType)) {
                            let defaultFileName = JobUtils.getDefaultFileName(
                                jobType,
                                sourceLocation,
                                source,
                                _.get(jobKeysToFilename, sourceKey),
                                null,
                                stitchAssetName,
                                isStitch);
                            return _.isEmpty(defaultFileName) ? null : (
                                <DraggableItem
                                    processFields={null}
                                    process={null}
                                    isMapped={_.size(_.get(deliveriesToSourceMapping, sourceKey, [])) > 0}
                                    isUnMapped={
                                        _.findIndex(unMappedSources, (unMappedSource) => {
                                            return _.get(unMappedSource, "key") === sourceKey;
                                        }) > -1
                                    }
                                    key={"draggable" + index}
                                    data={{ sources: [source] }}
                                    canDrag={true}
                                    title={defaultFileName}
                                    onFileNameUpdated={(filename) => onFileNameUpdated(filename, source, sourceKey)}
                                    jobType={extractedJobType}
                                    sourceLocation={extractedSourceLocation}
                                    onDragPrevent={onDragPrevent}
                                    isNoDelivery= {_.isEmpty(deliveries)} 
                                />
                            );
                        } else {
                            return _.map(processes, (process, processIndex) => {
                                let sourceProcessKey = buildSourceProcessKey(_.get(source, "key"), _.get(process, "key"));
                                let defaultFileName = JobUtils.getDefaultFileName(
                                    jobType,
                                    sourceLocation,
                                    source,
                                    _.get(jobKeysToFilename, sourceProcessKey),
                                    process,
                                    stitchAssetName, isStitch)
                                return _.isEmpty(defaultFileName) ? null : (
                                    <li key={"list" + index + processIndex}
                                        className="listStyleNone">
                                        <DraggableItem
                                            process={process}
                                            processFields={RequestUtils.getProcessMeta(jobType, sourceLocation)}
                                            isMapped={_.size(_.get(deliveriesToSourceMapping, sourceProcessKey, [])) > 0}
                                            isUnMapped={
                                                _.findIndex(unMappedSources, (unMappedSource) => {
                                                    return unMappedSource === sourceProcessKey;
                                                }) > -1
                                            }
                                            key={"draggable" + index + processIndex}
                                            data={{ sources: [source], process: process }}
                                            canDrag={true}
                                            title={defaultFileName}
                                            onFileNameUpdated={(filename) => onFileNameUpdated(filename, source, sourceProcessKey)}
                                            jobType={extractedJobType}
                                            sourceLocation={extractedSourceLocation}
                                            onDragPrevent={onDragPrevent}
                                            isNoDelivery= {_.isEmpty(deliveries)} 
                                        />
                                    </li>
                                );
                            });
                        }
                    })}
                </ul>
            </Row>
        </Container>
    );
}

export default React.memo(SourceDrag);